// eslint-disable-next-line import/no-extraneous-dependencies
import { PayloadAction, createSlice } from '@reduxjs/toolkit'

export interface Post {
  isSoundOn: boolean
  isBecomeOnline: boolean
  isBecomeOffline: boolean
  isGetAppModal: boolean
  isTryAppModal: boolean
  isActiveCaptions: boolean
  feedStateId: number
  isSlideChange: boolean
  isShareOpened: boolean
  isCommentsVisible: boolean
  isOpenBasket: boolean
  isAppointmentBookingOpen: boolean
  isButtonMenuVisible: boolean
}

const initialState: Post = {
  isSoundOn: false,
  isBecomeOnline: false,
  isBecomeOffline: false,
  isGetAppModal: false,
  isTryAppModal: false,
  isActiveCaptions: false,
  feedStateId: Math.round(Math.random() * 10000),
  isSlideChange: false,
  isShareOpened: false,
  isCommentsVisible: false,
  isOpenBasket: true,
  isAppointmentBookingOpen: true,
  isButtonMenuVisible: true
}

export const postSlice = createSlice({
  name: 'post',
  initialState,
  reducers: {
    setIsSoundOn: (state, action: PayloadAction<boolean>) => {
      // eslint-disable-next-line no-param-reassign
      state.isSoundOn = action.payload
    },
    setIsBecomeOnline: (state, action: PayloadAction<boolean>) => {
      // eslint-disable-next-line no-param-reassign
      state.isBecomeOnline = action.payload
    },
    setIsBecomeOffline: (state, action: PayloadAction<boolean>) => {
      // eslint-disable-next-line no-param-reassign
      state.isBecomeOffline = action.payload
    },
    setIsGetAppModal: (state, action: PayloadAction<boolean>) => {
      // eslint-disable-next-line no-param-reassign
      state.isGetAppModal = action.payload
    },
    setTryAppModal: (state, action: PayloadAction<boolean>) => {
      // eslint-disable-next-line no-param-reassign
      state.isTryAppModal = action.payload
    },
    setIsActiveCaptions: (state, action: PayloadAction<boolean>) => {
      // eslint-disable-next-line no-param-reassign
      state.isActiveCaptions = action.payload
    },
    setFeedStateId: (state, action: PayloadAction<number>) => {
      // eslint-disable-next-line no-param-reassign
      state.feedStateId = action.payload
    },
    setIsSlideChange: (state, action: PayloadAction<boolean>) => {
      state.isSlideChange = action.payload
    },
    setIsShareOpened: (state, action: PayloadAction<boolean>) => {
      state.isShareOpened = action.payload
    },
    setIsOpenBasket: (state, action: PayloadAction<boolean>) => {
      state.isOpenBasket = action.payload
    },
    setIsAppointmentBookingOpen: (state, action: PayloadAction<boolean>) => {
      state.isAppointmentBookingOpen = action.payload
    },
    setIsCommentsVisible: (state, action: PayloadAction<boolean>) => {
      state.isCommentsVisible = action.payload
    },
    setIsButtonMenuVisible: (state, action: PayloadAction<boolean>) => {
      state.isButtonMenuVisible = action.payload
    }
  },
})

// Action creators are generated for each case reducer function
export const {
  setIsSoundOn, setIsBecomeOnline, setIsBecomeOffline, setIsGetAppModal, setTryAppModal,
  setIsActiveCaptions, setFeedStateId, setIsSlideChange, setIsShareOpened, setIsOpenBasket,
  setIsAppointmentBookingOpen, setIsCommentsVisible, setIsButtonMenuVisible
} = postSlice.actions

export default postSlice.reducer
